import React, { useLayoutEffect, useRef } from 'react';
import { ArrowRight, Download } from 'lucide-react';
import { Link } from 'react-router-dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const Hero: React.FC = () => {
  const root = useRef<HTMLElement | null>(null);

  useLayoutEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;

    const context = gsap.context(() => {
      gsap.from('[data-hero-copy]', {
        opacity: 0,
        y: 28,
        duration: 0.85,
        ease: 'power3.out',
        stagger: 0.09,
      });
      gsap.fromTo(
        '[data-hero-product]',
        { opacity: 0, y: 48, scale: 0.94 },
        { opacity: 1, y: 0, scale: 1, duration: 1.05, ease: 'power3.out', delay: 0.18 },
      );
    }, root);

    return () => context.revert();
  }, []);

  return (
    <section ref={root} className="relative isolate overflow-hidden bg-[#07110d] text-white">
      <div className="mx-auto grid max-w-[1480px] items-center gap-9 px-5 py-14 sm:px-8 lg:grid-cols-[0.58fr_1.42fr] lg:px-10 lg:py-16">
        <div className="relative z-10 max-w-[470px]">
          <h1 data-hero-copy className="max-w-[12ch] text-[clamp(2.7rem,4.2vw,4.5rem)] font-semibold leading-[0.98] tracking-[-0.05em]">
            Un certificado por pestaña.
          </h1>
          <p data-hero-copy className="mt-5 max-w-[47ch] text-base leading-7 text-[#c9d7ce] sm:text-lg">
            Trabaja con varios portales y clientes a la vez. Certy mantiene cada sesión separada y lista para continuar.
          </p>
          <div data-hero-copy className="mt-7 flex flex-col gap-4 sm:flex-row sm:items-center">
            <Link to="/downloads" className="editorial-button editorial-button-primary px-6">
              <Download className="h-4 w-4" /> Descargar Certy
            </Link>
            <a href="#producto-en-accion" className="inline-flex items-center gap-2 text-sm font-semibold text-white hover:text-[#85f6aa]">
              Ver funciones <ArrowRight className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div data-hero-product className="relative min-w-0">
          <div className="overflow-hidden rounded-xl border border-white/15 bg-white shadow-[0_24px_60px_rgba(0,0,0,0.32)]">
            <img
              src="/product/certy-multiples-pestanas.webp"
              alt="Certy con cuatro portales abiertos en pestañas independientes, cada uno asociado a un certificado diferente"
              width="1600"
              height="900"
              fetchPriority="high"
              className="aspect-video w-full bg-white object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
